import Group3Fill from '@/assets/icons/group_3_fill.svg?component';
import LayoutGridFill from '@/assets/icons/layout_grid_fill.svg?component';
import LinkLine from '@/assets/icons/link_line.svg?component';
import Louse from '@/assets/icons/louse.svg?component';
import QuestionFill from '@/assets/icons/question_fill.svg?component';
import Transfer4Fill from '@/assets/icons/transfer_4_fill.svg?component';
import TransferFill from '@/assets/icons/transfer_fill.svg?component';
import VideoCamera2Fill from '@/assets/icons/video_camera_2_fill.svg?component';

import type { SidebarLevelConfig } from './types';

/** Location level. */
export const locationLevel: SidebarLevelConfig = {
    level: 'location',
    matchPattern: '/c/:clientId/location/:locationId',
    back: {
        title: 'sidebarItems.back.toRegion',
        urlTemplate: '/c/:clientId',
    },
    items: [
        {
            id: 'location-dashboard',
            label: 'sidebarItems.shared.dashboard',
            analyticsLabel: 'Dashboard',
            path: '',
            icon: LayoutGridFill,
            exact: true,
            children: [
                {
                    id: 'location-dashboard-biological',
                    label: 'sidebarItems.location.biologicalDashboard',
                    analyticsLabel: 'Biological',
                    path: '',
                    exact: true,
                },
                {
                    id: 'location-dashboard-operational',
                    label: 'sidebarItems.location.operationalDashboard',
                    analyticsLabel: 'Operational',
                    path: '/operational-dashboard',
                    exact: true,
                },
                {
                    id: 'location-dashboard-feeding',
                    label: 'sidebarItems.location.feedingDashboard',
                    analyticsLabel: 'Feeding',
                    path: '/feeding',
                    exact: true,
                    visibility: { requiredFeatureFlags: ['feeding-dashboard'] },
                },
                {
                    id: 'location-dashboard-fish-groups',
                    label: 'sidebarItems.location.fishGroups',
                    analyticsLabel: 'Fish groups',
                    path: '/fish-groups',
                    exact: true,
                    visibility: { requiredFeatureFlags: ['fish-groups-client-management'] },
                },
            ],
        },
        {
            id: 'location-lice-report',
            label: 'sidebarItems.shared.liceReport',
            analyticsLabel: 'Lice report',
            path: '/lice-report',
            icon: Louse,
            exact: true,
            visibility: { requiresLicenses: ['liceLicense'] },
        },
        {
            id: 'location-compare',
            label: 'sidebarItems.shared.compare',
            analyticsLabel: 'Compare',
            path: '/compare',
            icon: TransferFill,
            exact: true,
        },
        {
            id: 'location-video',
            label: 'sidebarItems.location.video',
            analyticsLabel: 'Video',
            path: '/video',
            icon: VideoCamera2Fill,
            exact: true,
            visibility: { requiresLicenses: ['liveStreamLicense'] },
        },
        {
            id: 'location-change-pen',
            label: 'sidebarItems.shared.changePen',
            analyticsLabel: 'Change pen',
            path: '/change-pen',
            icon: Transfer4Fill,
            exact: true,
            isStatic: true,
            visibility: [{ requiresClientAdmin: true }, { requiresCurrentLocationAdmin: true }],
        },
        {
            id: 'location-data-sources',
            label: 'sidebarItems.location.dataSources',
            analyticsLabel: 'Data sources',
            path: '/data-sources',
            icon: LinkLine,
            exact: true,
            isStatic: true,
            // One rule group, so the flag and the OptoScale-admin rule must both pass. Client
            // admins get the page later; the API refuses them until then too.
            visibility: {
                requiresOptoScaleAdmin: true,
                requiredFeatureFlags: ['provider-config-ui'],
            },
        },
        {
            id: 'location-users',
            label: 'sidebarItems.shared.users',
            analyticsLabel: 'Users',
            path: '/users',
            icon: Group3Fill,
            exact: true,
            isStatic: true,
            visibility: { requiresClientAdmin: true },
        },
        {
            id: 'location-help',
            label: 'sidebarItems.shared.help',
            analyticsLabel: 'Help',
            path: '/help',
            icon: QuestionFill,
            exact: true,
            isStatic: true,
        },
    ],
};
